import api from "@/store/api";
import router from "../../router/index"
import {randomString} from "../../utils";

export const csrfToken = 'csrf_onboarding';
export const browserId = 'hash';

export const token = () => {
    return localStorage.getItem(csrfToken);
};

export const intermediaryId = () => {
    return process.env.VUE_APP_INTERMEDIARY_ID;
};

export const browserHash = () => {
    return localStorage.getItem(browserId);
};

export default {
    namespaced: true,
    state:{
        currentStep: 0,
        countries: [],
        personalInfo: {},
        investmentProfile: "",
        investmentQuestionnaire: {},
        contracts: [],
        strategies: [],
        clientZoneUrl: '',
        questionnaireType: '',
        questionnaireTypeId: 0,
        intermediaryPersonFilled: false,
        selectedStrategy: null,
        strategyFeeConfig: {
            years: 0,
            monthly: 0,
            investment: 0,
            payment: 1,
            percent: 0,
        },
        feeTotal: null,
        investmentTotal: null,
        registered: false,
        serviceDown: false,
    },
    getters: {},
    actions: {
        testServiceDown(store: any) {
            return new Promise((resolve, reject) => {
                api.get('client-zone-users/service-down').then((response: any) => {
                    store.commit('setServiceDown', false);
                    resolve(response.data);
                }).catch(error => {
                    store.commit('setServiceDown', true);
                    reject();
                });
            });
        },
        getCurrentStep(store: any) {
            return new Promise((resolve, reject) => {
                api.get('sign/get-current-step').then((response: any) => {
                    if (response.data.result.step === '8') {
                        router.push({name: 'successScreen'});
                        store.commit('removeToken');
                    }
                    store.commit('setCurrentStep', response.data.result.step);
                    resolve(response);
                });
            });
        },
        getCountries(store: any) {
            return new Promise((resolve, reject) => {
                api.get('sign/countries').then((response: any) => {
                    store.commit('setCountries', response.data.result);
                    // resolve(response);
                });
            });
        },
        registration(store: any, params: any) {
            params.link = window.location.origin + process.env.VUE_APP_PUBLIC_PATH + '#/login/';
            params.intermediaryId = intermediaryId();
            return new Promise((resolve, reject) => {
                api.post('sign/registration', params).then(() => {
                   resolve();
                }).catch(error => {
                    const response = error.response.data.result;
                    store.dispatch("alert/warning", error.response.data.result, { root: true });
                    reject();
                });
            });
        },
        login(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post(`client-zone-users/login`, params).then((response: any) => {
                    store.commit('setToken', response.data.result.token);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        loginWithToken(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post(`client-zone-users/login-with-token-onboarding`, params).then((response: any) => {
                    store.commit('setToken', response.data.result.token);
                    router.push({name: 'home'});
                    resolve();
                }).catch(() => {
                    store.dispatch("alert/warning", 'Platnosť odkazu na pokračovanie v registrácii vypršala. Pre pokračovanie zopakujte registráciu s rovnakým rodným číslom / IČO-m.', { root: true });
                    store.commit('removeToken');
                    router.push({name: 'home'});
                    reject();
                });
            });
        },
        // sendActivationEmail(store: any) {
        //     const link = window.location.origin + '/#/activation/';
        //     return api.post('sign/send-activation-email', { link });
        // },
        // activate(store: any, params: any) {
        //     return new Promise((resolve, reject) => {
        //         api.post('sign/activate-email', params).then((response: any) => {
        //             resolve();
        //         }).catch((error) => {
        //             reject(error.response.data.result);
        //         });
        //     });
        // },
        sendPinCode(store: any, params: any) {
            return api.post('sign/send-pin-code');
        },
        logout(store: any) {
            store.commit('removeToken');
            window.location.reload();
        },
        savePersonalInfo(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/personal-info', params).then(() => {
                    resolve();
                }).catch((error) => {
                    store.dispatch(
                        "alert/warning",
                        error.response.data.result,
                        {root: true}
                    );
                    reject();
                });
            });
        },
        getPersonalInfo(store: any) {
            return new Promise((resolve, reject) => {
                api.get('sign/personal-info').then((response) => {
                    store.commit('setPersonalInfo', response.data.result.personalInfo);
                    resolve(response);
                });
            });
        },
        saveInvestmentQuestionnaire(store: any, params: any) {
            return api.post('sign/questionnaire', params).then((response) => {
                store.commit('setInvestmentQuestionnaire', response.data.result.questionnaire);
            });
        },
        getInvestmentQuestionnaire(store: any) {
            return api.get('sign/questionnaire').then((response) => {
                store.commit('setInvestmentQuestionnaire', response.data.result.questionnaire);
                store.commit('setQuestionnaireType', response.data.result.questionnaireType);
                store.commit('setQuestionnaireTypeId', response.data.result.questionnaireTypeId);
                store.commit('setIntermediaryPersonFilled', response.data.result.intermediary);
            });
        },
        getInvestmentProfile(store: any) {
            return api.get('sign/get-investment-profile').then((response: any) => {
                store.commit('setInvestmentProfile', response.data.result.profile);
            });
        },
        getContracts(store: any) {
            return api.get('sign/contracts').then((response: any) => {
                store.commit('setContracts', response.data.result);
            });
        },
        download(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/download', params).then((response) => {
                    const hex = response.data.result.file;
                    const binary = [];
                    for (let i = 0; i < hex.length / 2; i++) {
                        const h = hex.substr(i * 2, 2);
                        binary[i] = parseInt(h, 16);
                    }
                    const byteArray = new Uint8Array(binary);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = response.data.result.name;
                    link.click()
                    URL.revokeObjectURL(link.href);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        confirmSummary(store: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/confirm').then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        confirmStrategy(store: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/confirm-strategy').then((response) => {
                    store.commit('setCurrentStep', response.data.result.step);
                    store.commit('setPersonalInfo', response.data.result.personalInfo);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        confirmDocuments(store: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/confirm-documents').then((response) => {
                    store.commit('setCurrentStep', response.data.result.step);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        getStrategies(store: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/get-strategies').then((response) => {
                    store.commit('setStrategies', response.data.result.strategies);
                    store.commit('setQuestionnaireTypeId', response.data.result.questionnaireTypeId);
                    store.commit('setIntermediaryPersonFilled', response.data.result.intermediary);
                    resolve();
                }).catch(() => {
                    store.commit('setStrategies', []);
                    reject();
                });
            });
        },
        saveDocuments(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/documents', params).then(() => {
                    store.commit('setCurrentStep', 7);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        saveVerification(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/verification', params).then(() => {
                    store.commit('removeToken');
                    router.push({name: 'successScreen'});
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        sendSummaryEmail(store: any) {
            return api.post('sign/send-summary-email').then(() => {
                store.dispatch('logout');
            }).catch((error) => {
                store.dispatch('logout');
                console.log(error.response.data);
            });
        },
        sendLink(store: any) {
            const link = window.location.origin + process.env.VUE_APP_PUBLIC_PATH + '#/login/';
            return api.post('sign/send-link', { link }).then(() => {
                store.dispatch("alert/success", "Do vašej emailovej schránky sme zaslali odkaz na pokračovanie v registrácii platný po dobu 7 dní.", { root: true });
                store.commit('removeToken');
                setTimeout(function(){ window.location.reload(); }, 5000);
            }).catch((error) => {
                // console.log(error.response.data);
            });
        },
        clientZoneUrl(store: any) {
            let url;
            if (process.env.NODE_ENV === "development") {
                url = process.env.VUE_APP_CLIENT_ZONE_PATH
            } else {
                url = window.location.origin + process.env.VUE_APP_CLIENT_ZONE_PATH
            }
            store.commit('setUrl', url);
        },
        setStrategy(store: any, params: any) {
            store.commit('setSelectedStrategy', params.id);
            store.dispatch('calculateFees');
        },
        calculateFees(store: any) {
            return new Promise((resolve, reject) => {
                api.post('sign/calculate-fees', {
                    strategyId: store.state.selectedStrategy,
                    investmentFees: store.state.strategyFeeConfig,
                }).then((response) => {
                    store.commit('setFeeTotal', response.data.result.fee);
                    store.commit('setInvestmentTotal', response.data.result.investmentTotal);
                    resolve();
                }).catch((error) => {
                    console.log(error.response.data);
                    reject();
                });
            });
        },
        getFeesData(store: any) {
            return api.get('sign/get-fees-data');
        }
    },
    mutations: {
        setRegistration(state: any, bool: boolean) {
            state.registered = bool;
        },
        setCurrentStep(state: any, step: string) {
            state.currentStep = step;
        },
        setToken(state: any, token: string) {
            localStorage.setItem(csrfToken, token);
        },
        removeToken() {
            localStorage.removeItem(csrfToken);
        },
        setCountries(state: any, data: any) {
            state.countries = data;
        },
        setPersonalInfo(state: any, data: any) {
            state.personalInfo = data;
        },
        setInvestmentProfile(state: any, data: any) {
            state.investmentProfile = data;
        },
        setInvestmentQuestionnaire(state: any, data: any) {
            state.investmentQuestionnaire = data;
        },
        setQuestionnaireType(state: any, data: any) {
            state.questionnaireType = data;
        },
        setQuestionnaireTypeId(state: any, data: any) {
            state.questionnaireTypeId = data;
        },
        setIntermediaryPersonFilled(state: any, data: any) {
            state.intermediaryPersonFilled = data;
        },
        setContracts(state: any, data: any) {
            state.contracts = data;
        },
        setStrategies(state: any, data: any) {
            for (let i in data) {
                data[i].hover = false;
                data[i].focus = false;
            }
            state.strategies = data;
        },
        setUrl(state: any, url: string) {
            state.clientZoneUrl = url;
        },
        setFeeTotal(state: any, data: any) {
            state.feeTotal = data;
        },
        setInvestmentTotal(state: any, data: any) {
            state.investmentTotal = data;
        },
        initBrowser() {
            if (browserHash() === null) {
                localStorage.setItem(browserId, randomString(50));
            }
        },
        setSelectedStrategy(state: any, data: any) {
            state.selectedStrategy = data;
        },
        setStrategyFeesData(state: any, data: any) {
            state.strategyFeeConfig = data;
        },
        setServiceDown(state: any, value: boolean) {
            state.serviceDown = value;
        },
    }
}
